module.exports = __webpack_public_path__ + "media/stylesheets/images/main/openWaiting/openWaiting_mobile_economy-025c49ba665609560070be33764e102a.png";